module.exports = __webpack_public_path__ + "img/17850_S.b2fa155a.png";